<h4 class="stepper-page-title title-2 mb-4">Service Lines</h4>
@if (isLoading || !isServiceLineDetailFormBuild) {
  <div class="flex justify-center">
    @if (isLoading || !isServiceLineDetailFormBuild) {
      <p-progressSpinner />
    }
  </div>
}
<p-toast position="center" />
@if (isServiceLineDetailFormBuild && !showPreview) {
  <form [formGroup]="serviceLineDetailForm">
    <p-panel
      [toggleable]="false"
      header="Please select the applicable service line and then enter the required information.  When finished, click the Preview Service Lines button."
    >
      @if (canRequestNextReviewPeriod) {
        <p-message class="mb-4" [closable]="false" severity="warn" icon="pi pi-exclamation-triangle">
          {{ reviewPeriodMessage.detail }}
        </p-message>
      }
      @if (!isLoading) {
        <p-table
          [value]="serviceLineDetails"
          [(selection)]="selectedDetails"
          dataKey="hiddenUID"
          [scrollable]="true"
          scrollDirection="both"
          scrollHeight="flex"
          (onRowSelect)="handleDetailRowChecked($event)"
          (onRowUnselect)="handleDetailRowUnChecked($event)"
          >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 3.8rem"></th>
              <th style="width: 14rem">Date/Time<br>Request Received</th>
              <th style="width: 7rem">Skill</th>
              <th style="width: 7rem">Urgency</th>
              <th style="width: 10rem">Total Previously<br>Approved Visits</th>
              @if (hh30DayReviewPeriods) {
                <th style="width: 10rem">Review Period</th>
              }
              <th style="width: 14rem">Date Last Visit Delivered</th>
              @if (!hh30DayReviewPeriods) {
                <th style="width: 29rem">Services delivered between these dates are considered Retroactive. (Enter
                  the visits in the column to the right)
                </th>
              }
              @if (!hh30DayReviewPeriods) {
                <th style="width: 14rem">Number of Retro Visits Requested</th>
              }
              @if (!hh30DayReviewPeriods) {
                <th style="width: 26rem">Timely Visits Requested (Total Visits Requested - Number of Retro Visits Requested)</th>
              }
              @if (!hh30DayReviewPeriods) {
                <th style="width: 14rem">Total Visits<br>Being Requested</th>
              }
              @if (hh30DayReviewPeriods) {
                <th style="width: 14rem">Retroactive Date Range</th>
              }
              @if (hh30DayReviewPeriods) {
                <th style="width: 10rem">Retro Visits<br>Requested</th>
              }
              @if (hh30DayReviewPeriods) {
                <th style="width: 14rem">Timely Visits Requested<br>(Total Visits - Retro Visits)</th>
              }
              @if (hh30DayReviewPeriods) {
                <th style="width: 14rem">Total Visits<br>Requested</th>
              }
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-sl
            let-rowIndex="rowIndex"
            >
            <tr [pSelectableRow]="sl">
              <td class="disabled-max-col-width" style="width: 3.8rem">
                <p-tableCheckbox [value]="sl"></p-tableCheckbox>
              </td>
              <!-- utcToLocal pipe stopped working, - 203788, issue with dateTimeFaxRecieved format -->
              <td class="disabled-max-col-width" style="width: 14rem">{{sl.dateTimeFaxRecieved | date: 'MM/dd/yyyy hh:mm:ss a'}}</td>
              <td
                style="width: 7rem"
                pTooltip="{{sl.hcpcCode}}"
                tooltipPosition="bottom"
              >{{sl.skillCode | skillCode}}</td>
              <td class="disabled-max-col-width" style="width: 7rem">{{sl.urgency}}</td>
              <td class="disabled-max-col-width" style="width: 10rem">{{sl.totalPreviouslyApprovedVisits}}</td>
              @if (hh30DayReviewPeriods) {
                @if (sl.reviewPeriodType) {
                  <td
                    class="disabled-max-col-width"
                    style="width: 10rem"
                    pTooltip="{{sl.reviewPeriodStartDate | date:'MM/dd/yyyy'}} - {{sl.reviewPeriodEndDate | date:'MM/dd/yyyy'}}"
                    tooltipPosition="bottom">
                    <span>
                      {{ sl.reviewPeriodType === 'ReviewPeriodA' ? 'A' : 'B'}}
                    </span>
                    <span class="icon">
                      <i class="pi pi-exclamation-circle"></i>
                    </span>
                  </td>
                }
                @if (!sl.reviewPeriodType) {
                  <td
                    class="disabled-max-col-width"
                    style="width: 10rem">
                  </td>
                }
              }
              <td class="disabled-max-col-width" style="width: 14rem">{{sl.dateLastVisitDelivered | date: 'MM/dd/yyyy'}}</td>
              @if (!hh30DayReviewPeriods) {
                <td class="disabled-max-col-width" style="width: 29rem">{{sl.retroDateRange}}</td>
              }
              @if (!hh30DayReviewPeriods) {
                <td class="disabled-max-col-width" style="width: 14rem">{{sl.retroVisitsRequested}}</td>
              }
              @if (!hh30DayReviewPeriods) {
                <td class="disabled-max-col-width" style="width: 26rem">{{sl.timelyVisitsRequested}}</td>
              }
              @if (hh30DayReviewPeriods) {
                <td class="disabled-max-col-width" style="width: 14rem">{{sl.retroDateRange}}</td>
              }
              @if (hh30DayReviewPeriods) {
                <td class="disabled-max-col-width" style="width: 10rem">{{sl.retroVisitsRequested}}</td>
              }
              @if (hh30DayReviewPeriods) {
                <td class="disabled-max-col-width" style="width: 14rem">{{sl.timelyVisitsRequested}}</td>
              }
              <td class="disabled-max-col-width" style="width: 14rem">{{sl.totalVisitsRequested}}</td>
            </tr>
          </ng-template>
        </p-table>
      }
      <div class="flex justify-between mt-4">
        <div>
          <span
            class="service-line-note"
            [hidden]="!(selectedDetails && selectedDetails.length > 0)"
            >
            Unchecking a checkbox will remove that service line.
          </span>
        </div>
        <div class="flex justify-between">
          @if (canRequestNextReviewPeriod) {
            <next-review-period-request-button
              class="pr-2"
              [selectedDetails]="selectedDetails"
              [reviewPeriodB]="reviewPeriodB"
              (nextReviewPeriodChange)="nextReviewPeriodRequest($event)">
            </next-review-period-request-button>
          }
          <button
            pButton
            severity="secondary"
            type="button"
            label="Preview Service Lines"
            [disabled]="!selectedDetails || selectedDetails.length === 0"
            (click)="previewServiceLines()"
          ></button>
        </div>
      </div>
    </p-panel>
  </form>
}

@if (showPreview) {
  <p-panel
    [toggleable]="false"
    header="Review the service lines below. Click the Next button below to proceed."
    >
    @if (!isLoading) {
      <p-table
        [value]="serviceLinesPreview"
        [scrollable]="false"
        >
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
          <col style="width: 14rem">
          <col style="width: 7rem">
          <col style="width: 7rem">
          <col style="width: 7rem">
          <col style="width: 7rem">
          <col style="width: 7rem">
          <col style="width: 7rem">
          <col style="width: 7rem">
          <col style="width: 7rem">
          <col style="width: 7rem">
          @if (hh30DayReviewPeriods) {
            <col style="width: 7rem">
          }
          @if (isExternalUser) {
            <col style="width: 7rem">
          }
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>Date/Time<br>Request Received</th>
          <th>Skill</th>
          <th>Status</th>
          <th>Urgency</th>
          <th>Visits</th>
          <th>Service Type</th>
          <th>Effective From</th>
          <th>Effective To</th>
          <th>SOC</th>
          <th>Cert Period</th>
          @if (hh30DayReviewPeriods) {
            <th>Review Period</th>
          }
          @if (isExternalUser) {
            <th>Additional Comments</th>
          }
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-sl
        let-rowIndex="rowIndex"
        >
        <tr [class]="sl.isNew ? 'service-line-grid-new' : null">
          <!-- utcToLocal pipe stopped working, - 203788, issue with dateTimeFaxRecieved format  -->
          <td>{{sl.dateTimeFaxRecieved | date: 'MM/dd/yyyy hh:mm:ss a'}}</td>
          <td
            pTooltip="{{sl.hcpcCode}}"
            tooltipPosition="bottom"
          >{{sl.skillCode | skillCode}}</td>
          <td>{{sl.serviceStatus}}</td>
          <td>{{sl.urgency}}</td>
          <td>{{sl.visits}}</td>
          <td>{{sl.serviceType}}</td>
          <td>{{sl.effectiveFromDate | date: 'MM/dd/yyyy'}}</td>
          <td>{{sl.effectiveToDate | date: 'MM/dd/yyyy'}}</td>
          <td>{{sl.startOfCareDate | date: 'MM/dd/yyyy'}}</td>
          <td>
            <span pTooltip="{{sl.certPeriodDates}}" tooltipPosition="bottom">{{sl.certPeriod}}</span>
            <span class="icon"><i class="pi pi-exclamation-circle"></i></span>
          </td>
          @if (hh30DayReviewPeriods) {
            <td>
              <span pTooltip="{{sl.reviewPeriodDates}}" tooltipPosition="bottom">{{sl.reviewPeriodType === 'ReviewPeriodA' ? 'A' : 'B'}}</span>
              <span class="icon"><i class="pi pi-exclamation-circle"></i></span>
            </td>
          }
          @if (isExternalUser) {
            <td>
              <span pTooltip="{{sl.additionalComments}}" tooltipPosition="bottom">
                {{ sl.additionalComments?.length > 30 ? (sl.additionalComments | slice:0:30) + '...' : sl.additionalComments || '--'
                }}
              </span>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  }
  <div class="flex justify-end mt-4">
    <button
      pButton
      severity="secondary"
      type="button"
      label="Return To Service Line Details"
      (click)="returnToServiceLinesDetails()"
    ></button>
  </div>
</p-panel>
}

<p-dialog
  header="Adding Service Lines"
  appendTo="body"
  [(visible)]="displayServiceLineQuestion"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '400px' }"
  [minY]="70"
  [maximizable]="false"
  >
  <p>Do you have enough information to enter service lines?</p>
  <ng-template #footer>
    <button
      type="button"
      pButton
      icon="pi pi-check"
      class="mr-2"
      label="Yes"
      (click)="handleHasInfoForServiceLines(true)"
    ></button>
    <button
      type="button"
      pButton
      icon="pi pi-times"
      label="No"
      class="p-button-secondary"
      (click)="handleHasInfoForServiceLines(false)"
    ></button>
  </ng-template>
</p-dialog>

<app-hipps-code-dialog
  [show]="displayHippsCodeDialog"
  [submitBtn]="{text: 'Continue', icon: ''}"
  [cancelBtn]="{text: 'No HIPPS', icon: 'pi pi-times'}"
  (selectHippsCode)="handleHippsCode($event)"
  >
</app-hipps-code-dialog>

<app-cert-period-select
  [(visible)]="certPeriodModalVisible"
  [certPeriods]="certPeriods"
  (certPeriodSelected)="handleCertPeriodSelected($event)"
></app-cert-period-select>

